import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchPaymentStatus } from "./API";

class PaymentStatus extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        size: 10,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_paymentstatus",
        header: "Payment Status",
        size: 300,
      },
    ],

    rows: [{ bint_srno: 1, vac_paymentstatus: "Payment Status 1" }],
    formData: {
      bint_srno: 0,
      txtPaymentStatus: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Payment Status");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.savePaymentStatus,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtPaymentStatus,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_paymentstatus"]);
    const bint_srno = row.bint_srno,
      txtPaymentStatus = row.vac_paymentstatus;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtPaymentStatus,
      },
    });
    document.getElementById("txtPaymentStatus").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_paymentstatus"]);
    this.DeleteData(row.bint_srno, row.vac_paymentstatus);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListPaymentStatus",
    };
    fetchPaymentStatus(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.PaymentStatusList || [],
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtPaymentStatus").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          txtPaymentStatus: "",
        },
      },
      () => {
        document.getElementById("txtPaymentStatus").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationPaymentStatus = () => {
    let result = false;
    if (this.state.formData.txtPaymentStatus.length <= 0) {
      this.props.toastErrorMsg("Enter Payment Status", "txtPaymentStatus");
    } else {
      result = true;
    }
    return result;
  };

  savePaymentStatus = () => {
    this.trimFormData(() => {
      if (this.validationPaymentStatus()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SavePaymentStatus",
          bint_srno: this.state.formData.bint_srno,
          vac_paymentstatus: this.state.formData.txtPaymentStatus,
        };
        fetchPaymentStatus(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (
                res.data.PaymentStatusList &&
                res.data.PaymentStatusList.length > 0
              ) {
                rows = res.data.PaymentStatusList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in Save Payment Status.",
              error,
            );
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_paymentstatus) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_paymentstatus} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeletePaymentStatus(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeletePaymentStatus = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeletePaymentStatus",
      bint_srno: bint_srno,
    };
    fetchPaymentStatus(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (
            res.data.PaymentStatusList &&
            res.data.PaymentStatusList.length > 0
          ) {
            rows = res.data.PaymentStatusList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Payment Status. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.savePaymentStatus}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtPaymentStatus,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtPaymentStatus"
              label="Payment Status*"
              value={this.state.formData.txtPaymentStatus}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.savePaymentStatus}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Payment Status")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={30}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <PaymentStatus {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
